import { createSelector } from '@reduxjs/toolkit';
import { selectSecurity } from '../../store/selectors';

export const selectSecurityDetailsState = createSelector(selectSecurity, (detailsState) => detailsState.details);
export const selectConsolidatedSecurityHoldingsSummary = createSelector(selectSecurityDetailsState, (details) => details.consolidatedSecurityHoldingsSummary);
export const selectSecurityDetails = createSelector(selectSecurityDetailsState, (details) => details.securityDetails);
